export default __webpack_public_path__ + "static/blob-48-f22af1ecdb0b159c98b820af857a4256.svg";